import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=062d0812&scoped=true"
import script from "./QuickView.vue?vue&type=script&lang=js"
export * from "./QuickView.vue?vue&type=script&lang=js"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=062d0812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d0812",
  null
  
)

export default component.exports